import React, { useEffect, useState } from "react";

export default function ThousandPlusCounter() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (count >= 13) return;

    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev >= 13) {
          clearInterval(interval);
          return 13;
        }
        return prev + 1; // brzina brojanja
      });
    }, 200); // brzina animacije

    return () => clearInterval(interval);
  }, []);

  return (
    <h2 style={{ fontSize: "40px", fontWeight: "bold" }}>
      {count >= 7 ? "7" : count}
    </h2>
  );
}   